module.exports = __webpack_public_path__ + "img/dbc.6877d455.svg";